import { useEffect, useState } from 'react';

import { useModal } from 'context/ModalContext';
import { ConfirmacaoDaAcao, ResultadoDaAcao } from 'components/task-item/modal-actions/moldura-da-acao';

interface Props {
  callback: (obj: { id: string; message?: string }) => void;
  id: string;
  status: string | undefined;
  data?: any;
}

/** Dar ciência da Ação ECOA (ECN-57): confirma e passa ao "Mandou bem!" no próprio modal, como hoje. */
export default function ModalKnown(props: Props) {
  const modalID = 'validation-known';

  const { openModal, closeModal } = useModal();
  const { callback, id } = props;

  const [modalIsOpen, setIsOpen] = useState<boolean>(false);
  const [success, setSuccess] = useState(false);

  function handleClose() {
    closeModal();
    if (!!success) callback({ id: 'open_feedback' });
  }

  useEffect(() => {
    if (typeof id === 'string' && typeof openModal === 'string' && openModal === `${modalID}-${id}`) {
      setSuccess(false);
      setIsOpen(true);
    } else {
      setSuccess(false);
      setIsOpen(false);
    }
  }, [id, openModal]);

  if (!modalIsOpen) return <></>;

  if (success) {
    return (
      <ResultadoDaAcao title="Mandou bem!" onClose={handleClose}>
        Essa ação foi marcada como ciente.
      </ResultadoDaAcao>
    );
  }

  return (
    <ConfirmacaoDaAcao
      title="Ciente da Ação ECOA"
      onClose={handleClose}
      onConfirm={() => {
        callback({ id: 'known' });
        setSuccess(true);
      }}
    >
      <p className="m-0">Deseja confirmar a ciência da Ação ECOA?</p>
    </ConfirmacaoDaAcao>
  );
}
